/**
 * Created by Allan on 2025/05/13.
 * Contact 84880528@qq.com.
 * 短信推广页面
 */
import Vue from 'vue'
import App from './App'
import Vant from 'vant'
import router from './router'
import Http from './services/http/'
import { Base64 } from 'js-base64'
import getQueryVariable from '@/smspromo/services/getQueryVariable'
import './filter/'
import 'vant/lib/index.css'
import axios from 'axios'

Vue.use(Vant)
Vue.prototype.$http = Http;
Vue.config.productionTip = false;

// 路由拦截
router.beforeEach((to, from, next) => {
    //路由发生变化修改页面Title
    if(to.meta.title){
        document.title=to.meta.title
    }
    next();
});

new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/smspromo/main.js